import theme from '@styles/theme';
import { FLUID_SECTION_HORIZONTAL_OFFSET_CSS, FLUID_SECTION_HORIZONTAL_PADDING_CSS } from '@utils/fluidSectionHorizontalPadding';
export default {
  section: (backgroundColor?: string) => ({
    '--gallery-offset': FLUID_SECTION_HORIZONTAL_OFFSET_CSS,
    width: '100%',
    backgroundColor: backgroundColor || theme.rawColors.beige500
  }),
  headerWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: FLUID_SECTION_HORIZONTAL_PADDING_CSS
  },
  headerTitle: {
    marginBottom: 0,
    padding: 0
  },
  headerArrow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.rawColors.neutralBlack,
    transition: 'transform 0.2s ease',
    '&:hover': {
      transform: 'translateX(4px)'
    }
  },
  sliderWrapper: {
    width: '100%',
    position: 'relative',
    '.swiper-slide': {
      width: ['295px', '318px', '270px', '338px', '380px', '495px'],
      minWidth: ['295px', '318px', '270px', '338px', '380px', '495px'],
      flexShrink: 0,
      boxSizing: 'border-box',
      '& > a, & > img': {
        display: 'block',
        width: ['295px', '318px', '270px', '338px', '380px', '495px'],
        height: ['295px', '318px', '270px', '338px', '380px', '495px']
      }
    },
    '.swiper': {
      paddingBottom: ['24px', '24px', '20px', '24px', '28px', '40px']
    },
    '.swiper-scrollbar': {
      position: 'absolute',
      bottom: '0',
      left: 'var(--gallery-offset)',
      right: 'var(--gallery-offset)',
      width: 'auto',
      height: '2px',
      background: theme.rawColors.lightGrey400,
      borderRadius: '0'
    },
    '.swiper-scrollbar-drag': {
      backgroundColor: theme.rawColors.neutralBlack,
      borderRadius: '0',
      cursor: 'pointer'
    }
  },
  imageLink: {
    display: 'block',
    width: '100%'
  },
  image: {
    width: ['295px', '318px', '270px', '338px', '380px', '495px'],
    height: ['295px', '318px', '270px', '338px', '380px', '495px'],
    objectFit: 'cover',
    display: 'block',
    borderRadius: '4px'
  }
};